interface ErrorBannerProps {
  message: string;
}

/** Inline form/section error. `role="alert"` so it is announced immediately. */
export function ErrorBanner({ message }: ErrorBannerProps) {
  return (
    <div className="error-banner" role="alert">
      <i className="pi pi-exclamation-triangle" aria-hidden="true" />
      <span>{message}</span>
    </div>
  );
}
